import type { JSX } from 'react';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import styles from './styles/styles.module.scss';

export type LightboxPhotoProps = {
  url?: string;
  title?: string;
  isLoading: boolean;
};

// https://www.figma.com/file/KYgIXAiEuiuBQoIQ5Tm3qf/Lightbox?node-id=11%3A2107&mode=dev
const LightboxPhoto = ({ url, title, isLoading }: LightboxPhotoProps): JSX.Element => {
  if (isLoading) {
    return <LoadingSpinner className={styles.loadingSpinner} testId="loading-spinner" />;
  }

  return (
    <div className={styles.lightboxContent}>
      <div className={styles.imageContainer}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={url} className={styles.mainImage} alt={title} />
        <div className={styles.backgroundImage} style={{ backgroundImage: `url(${url})` }} data-testid="background-image" />
      </div>
    </div>
  );
};

export default LightboxPhoto;
